import React from "react";

import NewsPageHeader from "~/components/NewsPageHeader";

import { getTopic } from "~/components/KnowledgeCenterCard";
import { getTopicNameTranslation } from "~/utilities/helpers";

import { useTranslationContext } from "~/context/TranslationContext";

const ArticlePageHeader = ({ data }) => {
    const {
        wpArticle: {
            title,
            articleTopics,
            primaryTopic: { primaryTopic },
            articleOptions: { breadcrumbsAtTop },
        },
    } = data;

    const { activeCode } = useTranslationContext();

    const topic = getTopic(primaryTopic, articleTopics.nodes);

    const translatedName = getTopicNameTranslation(
        topic?.name,
        articleTopics?.nodes,
        activeCode,
    );

    const category = translatedName?.translation ?? topic?.name;

    return (
        <NewsPageHeader {...{ title, breadcrumbsAtTop }} category={category} />
    );
};

export default ArticlePageHeader;
